// Simple request locking utility for methods that need extra protection
class RequestLock {
  constructor() {
    this.locks = new Map()
  }

  // Lock a method by key
  async execute(key, asyncFunction) {
    if (this.locks.has(key)) {
      console.log(`Request blocked - ${key} already in progress`)
      return null
    }

    try {
      this.locks.set(key, true)
      const result = await asyncFunction()
      return result
    } finally {
      this.locks.delete(key)
    }
  }

  // Check if locked
  isLocked(key) {
    return this.locks.has(key)
  }

  // Manual unlock (emergency)
  unlock(key) {
    this.locks.delete(key)
  }

  // Clear all locks
  clear() {
    this.locks.clear()
  }
}

// Global instance
export const requestLock = new RequestLock()

// Vue mixin for easy component usage
export const RequestLockMixin = {
  methods: {
    async lockAndExecute(key, asyncFunction) {
      return await requestLock.execute(key, asyncFunction)
    },
    isRequestLocked(key) {
      return requestLock.isLocked(key)
    },
    unlockRequest(key) {
      requestLock.unlock(key)
    }
  }
}